import {Component, OnInit, ViewChild, AfterViewChecked, Input, Output, Inject, OnDestroy} from '@angular/core';

declare var $: any;
import * as moment from 'moment';
import {EmployeeService} from '../../../services/employee.service';
import {Resource} from '../../../entities/Resource';
import {Priorities, Statuses, Task} from '../../../entities/Task';
import {TaskService} from '../../../services/task.service';
import {environment} from '../../../../environments/environment';
import {TimeplanService} from '../../../services/timeplan.service';
import {ResourceTaskTime} from '../../../entities/ResourceTaskTime';
import {Observable} from 'rxjs'
import {CalendarService} from '../../../services/calendar.service';
import {Calendar, CalendarFilter} from '../../../entities/Calendar';
import {ActivatedRoute} from '@angular/router';
import {ConverterService} from '../../../services/converter.service';
import {Job} from '../../../entities/Job';
import {JobService} from '../../../services/job.service';
import {discardPeriodicTasks} from '@angular/core/testing';
import {TaskPageModel, TaskTypes} from '../../../entities/PageModel';
import {ConfigService} from '../../../services/config.service';
import {ApproveEventsModel} from '../../../entities/ApproveEventsModel';
import {ResourceTaskTimeService} from '../../../services/resource-task-time.service';
import {LoginService} from '../../../services/login.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.css']
})
export class SchedulerComponent implements OnInit, OnDestroy {

  calendar: Calendar = null;

  unPlannedTasks: TaskPageModel = null;

  plannedTasks: TaskPageModel = null;

  employees: Resource[];

  employeeEvents: ResourceTaskTime[];

  subscription;
  jobSubscription;

  routeParams: any;

  firstRun: Boolean;

  calendarDate: string;

  taskRef: string = null;

  ChosenJob: Job;
  ChosenTask: Task;
  JobTasks: Task[];


  calendarTask: Task = null;

  maxResourceNameLength: number = 1;

  isAdmin: boolean = false;


  @ViewChild('dumbComp') child;

  constructor(private employeeService: EmployeeService,
              private taskservice: TaskService,
              private timePlanService: TimeplanService,
              private calendarService: CalendarService,
              private ConvertService: ConverterService,
              private jobservice: JobService,
              private loginService: LoginService,
              private route: ActivatedRoute,
              private config: ConfigService,
              private location: Location,
              private resourceTaskTimeService: ResourceTaskTimeService) {
  }

  ngOnInit() {
    this.firstRun = true;
    this.route.params.subscribe(params => this.routeParams = params);
    this.isAdmin = this.loginService.isAdmin();
    this.calendarDate = this.routeParams['date'];
    this.taskRef = this.routeParams['taskref'];

    let sub = this.employeeService.getAllUsers().subscribe(resources => {
      this.setResources(resources);
      /* NEW */
      sub.unsubscribe();


      this.jobSubscription = this.config.observableJob.subscribe(x => {
        if (!this.firstRun) {
          this.location.go('/scheduler');
          this.taskRef = null;
          this.calendarTask = null;
          this.plannedTasks.PageIndex = 1;
          this.unPlannedTasks.PageIndex = 1;
          this.refreshCalendar()
        }
      });

      this.refreshCalendar();
    });
    //this.taskservice.getUnassignedTasks().subscribe(tasks => {this.externalTasks = tasks;});

  }


  ngOnDestroy() {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
    }
    if (this.jobSubscription != null) {
      this.jobSubscription.unsubscribe();
    }
  }

  setResources(resources) {
    this.maxResourceNameLength = 1;
    resources.forEach(x => {
      x.id = x.No;
      x.groupId = x.ResourceGroupName;
      if (x.No.length > this.maxResourceNameLength) {
        this.maxResourceNameLength = x.No.length
      }
      if (!!x.ResourceGroupName) {
        if (x.ResourceGroupName.length > this.maxResourceNameLength) {
          this.maxResourceNameLength = x.ResourceGroupName.length;
        }
      }
    });
    this.employees = resources;
  }

  // Calls the service to save the updated task data, after converting the dateTime.
  updateTask(taskToUpdate: Task) {
    this.taskservice.putTaskInfo(taskToUpdate).subscribe();
  }

  updateTimePlan(resourceTaskTime: ResourceTaskTime) {
    this.timePlanService.updateTimePlan(this.ConvertService.ConvertFromSchedulerDate(resourceTaskTime, true)).subscribe(() => {
    });
  }


  updateRTT(resourceTaskTime: ResourceTaskTime) {
    this.timePlanService.updateTimePlan(resourceTaskTime).subscribe(() => {
    });
  }


  removeEmpTimePlan(resourceTaskTime: ResourceTaskTime) {
    this.timePlanService.removeTimePlan(resourceTaskTime).subscribe(() => {
    });
  }

  // Call the servies to get fresh data to the calendar.
  refreshCalendar() {
    this.ChosenJob = this.config.chosenJob;
    if (this.taskRef != null && this.taskRef != 'Hele Sagen' && this.ChosenJob != null) {
      let sub = this.calendarService.getCalendarForAll(this.employees).subscribe(calendar => {

        this.calendar = this.ConvertService.convertToCalendar(calendar);
        this.taskservice.getTask(this.taskRef).subscribe(task => {

          this.plannedTasks = new TaskPageModel();
          this.plannedTasks.PageIndex = 1;
          this.plannedTasks.TotalCount = 1;
          this.plannedTasks.Tasks = [];

          this.unPlannedTasks = new TaskPageModel();
          this.unPlannedTasks.PageIndex = 1;
          this.unPlannedTasks.TotalCount = 1;
          this.unPlannedTasks.Tasks = [];
          this.unPlannedTasks.Tasks.push(task);
          let taskSub = this.taskservice.getTasksFromJob(this.ChosenJob.No).subscribe(tasks => {
            this.JobTasks = tasks.filter(x => moment(x.start).utc().format(environment.FULL_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_FULL && moment(x.end).utc().format(environment.FULL_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_FULL);
            this.renderCalendarForSpecificTask(task);
            taskSub.unsubscribe()
          });


        });
        //this.child.rerenderCalendar(this.calendar);
        sub.unsubscribe()
      });
      //this.title = task.Title;
    } else if (this.ChosenJob != null && this.ChosenJob.No != 'Alle sager') {
      //let sub = this.calendarService.getCalendarForAllForJob(this.employees, this.ChosenJob.No).subscribe(calendar => {
      let sub = this.calendarService.getCalendarForAll(this.employees).subscribe(calendar => {
        this.calendar = this.ConvertService.convertToCalendar(calendar);

        //this.refreshUnplannedTasksForJob(1);
        //this.refreshPlannedTasksForJob(1);
        let taskSub = this.taskservice.getTasksFromJob(this.ChosenJob.No).subscribe(tasks => {
          this.JobTasks = tasks.filter(x => moment(x.start).utc().format(environment.FULL_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_FULL && moment(x.end).utc().format(environment.FULL_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_FULL);
          taskSub.unsubscribe()
        });

        this.renderCalendarForSpecificJob();

        this.child.rerenderCalendar(this.calendar);
        sub.unsubscribe()
      });

      let t1 = new TaskPageModel();
      t1.Type = TaskTypes.Planned;
      t1.JobNo = this.ChosenJob.No;
      let t2 = new TaskPageModel();
      t2.Type = TaskTypes.UnPlanned;
      t2.JobNo = this.ChosenJob.No;

      if (this.unPlannedTasks != null && this.plannedTasks != null) {
        t1.PageIndex = this.plannedTasks.PageIndex;
        t1.SearchInput = this.plannedTasks.SearchInput;
        t2.PageIndex = this.unPlannedTasks.PageIndex;
        t2.SearchInput = this.unPlannedTasks.SearchInput;
      } else {
        t1.PageIndex = 1;
        t2.PageIndex = 1;
      }

      this.refreshFilteredTasks(t1);
      this.refreshFilteredTasks(t2);
    } else {
      let sub = this.calendarService.getCalendarForAll(this.employees).subscribe(calendar => {
        this.calendar = this.ConvertService.convertToCalendar(calendar);


        //this.refreshUnplannedTasks(1);
        //this.refreshPlannedTasks(1);
        this.child.rerenderCalendar(this.calendar);
        sub.unsubscribe()
      });

      let t1 = new TaskPageModel();
      t1.Type = TaskTypes.Planned;
      let t2 = new TaskPageModel();
      t2.Type = TaskTypes.UnPlanned;

      if (this.unPlannedTasks != null && this.plannedTasks != null) {
        t1.PageIndex = this.plannedTasks.PageIndex;
        t1.SearchInput = this.plannedTasks.SearchInput;
        t2.PageIndex = this.unPlannedTasks.PageIndex;
        t2.SearchInput = this.unPlannedTasks.SearchInput;
      } else {
        t1.PageIndex = 1;
        t2.PageIndex = 1;
      }

      this.refreshFilteredTasks(t1);
      this.refreshFilteredTasks(t2);
    }
  };


  refreshFilteredTasks(taskPageModel: TaskPageModel) {
    this.taskservice.getFilteredTasks(taskPageModel).subscribe(pTasks => {

      if (taskPageModel.Type == TaskTypes.Planned) {
        this.plannedTasks = pTasks;

      } else {
        this.unPlannedTasks = pTasks;
      }
      this.changeTaskPage(taskPageModel);
    });
  }

  changeTaskPage(pageModel: TaskPageModel) {
    switch (pageModel.Type) {
      case TaskTypes.Planned:
        this.plannedTasks.PageIndex = pageModel.PageIndex;
        break;
      case TaskTypes.UnPlanned:
        this.unPlannedTasks.PageIndex = pageModel.PageIndex;
        break;
    }
  }

  renderCalendarForSpecificJob() {
    //this.taskservice.getTask(this.taskRef).subscribe(task => {
    //this.calendarTask = task;
    this.calendar.ResourceTaskTimes.forEach(
      x => {
        x.color = x.JobNo != this.ChosenJob.No ? '#DA000D' : x.color;
        x.title = x.JobNo != this.ChosenJob.No ? '' : x.title;
        x.constraint = x.JobNo != this.ChosenJob.No ? '1' : null;
      }
    );
  }

  // light blue : '#337ab7'
  renderCalendarForSpecificTask(task) {
    this.calendarTask = task;
    this.calendar.ResourceTaskTimes.forEach(x => {
      if (x.TaskRef == this.taskRef) {
        x.constraint = x.TaskRef;
        x.color =
          moment(x.start).format(environment.FULL_DATETIME_FORMAT) < moment(this.calendarTask.start).format(environment.FULL_DATETIME_FORMAT) ||
          x.end > moment(new Date(this.calendarTask.end).setDate(new Date(this.calendarTask.end).getDate() + 1)).format()
            ? '#DA000D'
            : x.color
      }

      if (x.TaskRef != this.taskRef) {
        x.rendering = 'background';
        x.color = '#DA000D';
      }
      ;
    });

    this.calendar.ResourceTaskTimes.push(this.ConvertService.ConvertToVisualConstraint(this.calendarTask.Task_GUID, this.calendarTask.start, this.calendarTask.end));
    this.ChosenTask = task;
  }


  changeJobTask(taskRef: string) {
    this.location.go('/scheduler/' + 'Opgave/' + taskRef);
    this.taskRef = taskRef;
    if (taskRef == 'Hele Sagen') {
      this.calendarTask = null;
    }
    this.refreshCalendar();
  }


  setApprovedOnCurrentEvents(model: ApproveEventsModel) {
    this.resourceTaskTimeService.SetApprovedOnRTTsByFilter(model).subscribe(result => this.refreshCalendar());
  }

  removeAllEventsBasedOnFilter(model: ApproveEventsModel) {
    this.resourceTaskTimeService.RemoveAllEventsBasedOnFilter(model).subscribe(result => this.refreshCalendar());
  }
}








// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/scheduler/scheduler.component.ts